module.exports = __webpack_public_path__ + "img/injectionsteps_step5.79c0406b.png";